var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.lgAndUp)?_c('v-col',{class:{
		'mr-1': true,
		score: true,
		maxScore: _vm.value == _vm.maxScore,
	},attrs:{"cols":"auto","align":"center"}},[_vm._v(" "+_vm._s(_vm._f("doubleZero")(_vm.value >= 10 ? _vm.value : ('0' + _vm.value)))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }